import angular from 'angular';
import treatAdminFormComponent from './treat-admin-form.component';

export default angular.module('components.app.product.treatAdminForm', [])
  .component('treatAdminForm', treatAdminFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/treat-admin-form/treat-admin-form.module.js